import { fetchSelectedClaim } from '@declaration/services/fetchSelectedClaim';
const middleware = ({ store, redirect, app: { localePath } }) => {
    // Le backend est injoignable (settings KO, ou un autre appel de contexte en
    // échec) : contextEntitiesFetched a déjà basculé sur l'étape de maintenance,
    // on ne charge donc pas la claim et on ne redirige pas ailleurs.
    if (!store.getters['settings/areSettingsFetched'] || store.getters['pages/isInMaintenance']) {
        return;
    }
    return fetchSelectedClaim(store).then((state) => {
        if (!state || state.claim.claim.id === null) {
            return redirect(localePath('index'));
        }
    });
};
export default middleware;
